<template>
  <Modal v-model="platformCustomizedMaterialsModal" :title="$t('key1001192')" width="800" class-name="commonModalStyles"
    :transfer="false" :mask-closable="false">
    <h2 class="font-size-13 color-666 mb20">{{ $t('key1005973') }}</h2>
    <div class="flex align-items-start wid100P">
      <span class="width_100 text-align-right">{{ imgName }}</span>
      <div class="imgagesList_box" v-if="sourceMaterialImgList.length >0">
        <div class="imgagesList_box_item" v-for="(item,idx) in sourceMaterialImgList" :key="idx"
          :class="{ selected: selectedImages.includes(idx) }" @click="toggleSelection(idx)">
          <img class="img-styles" :src="setImgPath(item.path, null, null, null, false)"
            @error="setErrorImg($event)" alt=""/>
          <div v-if="selectedImages.includes(idx)" class="corner-triangle">
            <span class="corner-triangle-txt">✔</span>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <Button @click="cancelBtn">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="selectedImages.length <=0" @click="platformCustomizedMaterialsBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'platformCustomizedMaterialsModal',
  mixins: [Mixin],
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      platformCustomizedMaterialsModal: false,
      selectedImages: [],
      imgName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001528'),
      optionsType: 'materialImage',
      sourceMaterialImgList: [],
      currentIndex: 0,
    };
  },
  methods: {
    // 初始化数据
    initPlatformCustomizedMaterialsData(type, currentIndex) {
      this.imgName = type === 'materialImage' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001528') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001529');
      this.optionsType = type;
      this.currentIndex = currentIndex;
      let imageType = type === 'materialImage' ? 1 : 2;
      this.sourceMaterialImgList = this.imgList.filter(item => item.imageType === imageType);
      if (this.sourceMaterialImgList.length > 0) {
        this.selectedImages = [0];
      }
      this.platformCustomizedMaterialsModal = true;
    },
    // 选择图片
    toggleSelection(index) {
      const pos = this.selectedImages.indexOf(index);
      if (pos > -1) {
        this.selectedImages.splice(pos, 1);
      } else {
        this.selectedImages.push(index);
      }
    },
    // 取消
    cancelBtn() {
      this.selectedImages = [];
      this.sourceMaterialImgList = [];
      this.platformCustomizedMaterialsModal = false;
    },
    // 确定
    platformCustomizedMaterialsBtn() {
      let list = [];
      this.sourceMaterialImgList.map((item, index) => {
        if (this.selectedImages.includes(index)) {
          list.push(item.path);
        }
      });
      let obj = {
        currentIndex: this.currentIndex,
        imgList: list,
        optionsType: this.optionsType
      };
      this.$emit('updateImgData', obj);
      this.platformCustomizedMaterialsModal = false;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .commonModalStyles {
  .imgagesList_box {
    display: flex;
    flex-wrap: wrap;

    .imgagesList_box_item {
      margin: 0 14px 14px 0;
      position: relative;
      cursor: pointer;
      width: 100px;
      height: 100px;
      border: 2px solid transparent;
      box-sizing: border-box;
      transition: border 0.3s;

      .img-styles {
        width: 100%;
        height: 100%;
        object-fit: cover;
        /*border: 1px solid #ddd;*/
      }

      .corner-triangle {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 0;
        height: 0;
        border-left: 20px solid transparent; /* 三角形宽度 */
        border-bottom: 20px solid #FD5425;

        .corner-triangle-txt {
          position: absolute;
          top: 4px;
          left: -11px;
          color: #fff;
        }
      }
    }

    .imgagesList_box_item.selected {
      border: 2px solid #FD5425;
    }
  }
}
</style>